// extracted by mini-css-extract-plugin
module.exports = {"select":"o0KgbT4Q0m5Yfr9ce7Rh","numberInputWrapper":"kQjgEKemUlbUP20R0tUJ"};